import React from "react"
import _ from "lodash"

export default function TypeDropdown({ value, options, description, name }) {
  switch (name) {
    case "group_supervision__program_identity_ids": {
      const programs = _.map(value, ({ label }) => label)
      return <div>{_.join(programs, ", ")}</div>
    }

    case "session__program_identity_ids": {
      const programsGroupSession = _.map(value, ({ label }) => label)
      return <div>{_.join(programsGroupSession, ", ")}</div>
    }
    case "activity__program_identity_ids": {
      const programsActivities = _.map(value, ({ label }) => label)
      return <div>{_.join(programsActivities, ", ")}</div>
    }

    case "manage_staff_id_selector":
      return <div>{_.get(value, "label", "")}</div>

    case "manage_location_ids":
      const locations = _.map(value, ({ label }) => label)
      return <div>{_.join(locations, ", ")}</div>

    case "manage_program_identity_ids":
      const programsManageService = _.map(value, ({ label }) => label)
      return <div>{_.join(programsManageService, ", ")}</div>

    case "membership__staff_id_selector":
      return <div>{_.get(value, "label", "")}</div>

    case "staff_primary_supervisor":
      return <div>{_.get(value, "label", "")}</div>

    case "staff_role":
      return <div>{_.get(value, "label", "")}</div>

    default: {
      return <div>{_.find(options, { value })?.label} </div>
    }
  }
}
